import React, { useState } from 'react';
import { Bike, Bus, CarTaxiFront, Check, Lock, Truck } from 'lucide-react';
import { OwnerButton, OwnerShell } from '../OwnerShell';
import { FlowSteps } from '../FlowSteps';
import type { OwnerNav, OwnerVehicleType } from '../../../types/owner';
const options: {
  key: OwnerVehicleType;
  title: string;
  sub: string;
  icon: typeof Bike;
  tone: string;
}[] = [{
  key: 'cng',
  title: 'সিএনজি / অটোরিকশা',
  sub: 'রুট পারমিট ও ফিটনেস প্রযোজ্য • একাধিক চালক যুক্ত করা যাবে',
  icon: CarTaxiFront,
  tone: 'bg-bdgreen-600'
}, {
  key: 'motorcycle',
  title: 'মোটরসাইকেল',
  sub: 'মালিক নিজে বা অনুমোদিত রাইডার',
  icon: Bike,
  tone: 'bg-navy-800'
}];
export function OwnerAddVehicle({
  nav
}: {
  nav: OwnerNav;
}) {
  const [sel, setSel] = useState<OwnerVehicleType | null>(null);
  return <OwnerShell nav={nav} title="নতুন গাড়ি যুক্ত করুন" bodyClassName="p-0" footer={<OwnerButton disabled={!sel} onClick={() => {
    if (!sel) return;
    nav.startDraft(sel);
    nav.go('vehicleForm');
  }} data-id="element-1362" data-mp="2ooh4xzjuyma7">পরবর্তী ধাপ</OwnerButton>} data-id="element-1361" data-mp="2tntvovduodi2">
      <FlowSteps current={0} data-id="element-1363" data-mp="2ifqwvtxanas0" />
      <div className="px-4 py-4" data-id="element-1364" data-mp="2ngn52joohj38">
        <h2 className="font-heading text-lg font-bold text-navy-900" data-id="element-1365" data-mp="2nflro8k6wkic">গাড়ির ধরন নির্বাচন করুন</h2>
        <p className="text-sm text-slate-500" data-id="element-1366" data-mp="28iumtjrqyglc">আপনি কোন ধরনের গাড়ি নিবন্ধন করতে চান?</p>
        <div className="mt-4 space-y-3" role="radiogroup" aria-label="গাড়ির ধরন" data-id="element-1367" data-mp="2dhphpk2znvlt">
          {options.map(o => {
          const on = sel === o.key;
          return <button key={o.key} role="radio" aria-checked={on} onClick={() => setSel(o.key)} className={`relative flex w-full flex-col items-center overflow-hidden rounded-2xl border-2 bg-white p-5 text-center transition ${on ? 'border-navy-700 ring-4 ring-navy-100' : 'border-slate-200'}`} data-id="element-1368" data-mp="24ikjyfz946ap">
                {on && <span className="absolute right-3 top-3 flex h-6 w-6 items-center justify-center rounded-full bg-navy-800 text-white" data-id="element-1369" data-mp="1kul78zl4mp2n"><Check className="h-4 w-4" strokeWidth={3} data-id="element-1370" data-mp="3nh0e7nbo3vkq" /></span>}
                <span className={`flex h-20 w-20 items-center justify-center rounded-2xl text-white ${o.tone}`} data-id="element-1371" data-mp="3iq0bu2js4lau"><o.icon className="h-11 w-11" strokeWidth={1.6} data-id="element-1372" data-mp="3dqx9wqz3iv73" /></span>
                <span className="mt-3 font-heading text-lg font-bold text-navy-900" data-id="element-1373" data-mp="3dr730nfftih0">{o.title}</span>
                <span className="mt-0.5 text-xs text-slate-500" data-id="element-1374" data-mp="38tnjb7zz0dho">{o.sub}</span>
              </button>;
        })}
        </div>
        <p className="mb-2 mt-5 text-xs font-semibold text-slate-500" data-id="element-1375" data-mp="5bdm47h724zf">ভবিষ্যৎ সম্প্রসারণ (এখন নিবন্ধনযোগ্য নয়)</p>
        <div className="grid grid-cols-3 gap-2" data-id="element-1376" data-mp="b9bgy2yw4h4">
          {[{
          l: 'ব্যক্তিগত গাড়ি',
          i: CarTaxiFront
        }, {
          l: 'বাস',
          i: Bus
        }, {
          l: 'ট্রাক',
          i: Truck
        }].map(x => <div key={x.l} className="relative flex flex-col items-center gap-1 rounded-xl border border-dashed border-slate-300 bg-white p-3 text-[11px] text-slate-400" aria-disabled data-id="element-1377" data-mp="2l31erqp6dbcf">
              <Lock className="absolute right-1.5 top-1.5 h-3 w-3" data-id="element-1378" data-mp="wjf5zskt302j" />
              <x.i className="h-6 w-6" data-id="element-1379" data-mp="10k7g0o1i58zv" />
              {x.l}
            </div>)}
        </div>
      </div>
    </OwnerShell>;
}